import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import Typography, { TypographyProps } from '@mui/material/Typography'
import React from 'react'

function LoadingIndicator({
    loading,
    variant = 'linear',
    label,
    labelPlacement = 'top',
    labelSx = {},
}: {
    loading: boolean
    variant: 'linear' | 'circular'
    label: string
    labelPlacement: 'top' | 'left' | 'bottom' | 'right'
    labelSx: TypographyProps['sx']
}) {
    if (!loading) return null

    if (!['linear', 'circular'].includes(variant)) {
        throw new Error("variant must be 'linear' or 'circular'")
    }

    // Ensure consistent sizing for LinearProgress in row layouts
    const component =
        variant === 'linear' ? (
            <div style={{ flex: 1 }}>
                <LinearProgress />
            </div>
        ) : (
            <CircularProgress />
        )

    if (!label) return component
    if (!['top', 'bottom', 'left', 'right'].includes(labelPlacement)) {
        throw new Error("labelPlacement must be 'top', 'bottom', 'left', or 'right'")
    }

    if (labelPlacement === 'top') {
        return (
            <Stack spacing={1} direction='column'>
                <Typography variant='body1' sx={labelSx}>
                    {label}
                </Typography>
                {component}
            </Stack>
        )
    }
    if (labelPlacement === 'bottom') {
        return (
            <Stack spacing={1} direction='column'>
                {component}
                <Typography variant='body1' sx={labelSx}>
                    {label}
                </Typography>
            </Stack>
        )
    }
    if (labelPlacement === 'left') {
        return (
            <Grid container spacing={1} direction='row' alignItems='center' wrap='nowrap'>
                <Grid>
                    <Typography variant='body1' sx={labelSx}>
                        {label}
                    </Typography>
                </Grid>
                <Grid style={{ flex: 1 }}>{component}</Grid>
            </Grid>
        )
    }
    if (labelPlacement === 'right') {
        return (
            <Grid container spacing={1} direction='row' alignItems='center' wrap='nowrap'>
                <Grid style={{ flex: 1 }}>{component}</Grid>
                <Grid>
                    <Typography variant='body1' sx={labelSx}>
                        {label}
                    </Typography>
                </Grid>
            </Grid>
        )
    }
}

export default LoadingIndicator
